import { Component, Inject, OnDestroy, OnInit, PLATFORM_ID, QueryList, ViewChildren, ViewChild, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthFlowState, Credentials, OrgLogo, PatientSelectForm, PortalLoginMainObj, SelectedBranchObj, SelectedPatient, VerificationForm, PersonalDetailsForm, ChooseAndConfirmPassword, ConfirmItsYou, PatientForgetpatientobj } from './interface';
import { Subscription } from 'rxjs';
import { PatientPortalAPI } from '../../../Services/API/patient-portal-api';
import { AbstractControl, FormControl, FormGroup, ReactiveFormsModule, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { DateUtil, FaviconService, FormControls, MMDDYYYYFormatter, MobileNoUtil, PatientPortalLogService, PortalSessionDataService, SESSION_KEYS } from '../../../Shared/utilities';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { Ehnoteparent } from '../../../Services/API/ehnoteparent';
import { OtpForm, OtpObject, ReceiveOtpObject } from '../login/interface';
import { CountDownPipe } from '../../../Pipes/count-down-pipe';
import { PortalAuthContextService } from '../../../Services/Authorization/portal-auth.service';
import { Router } from '@angular/router';
import { UsMobileFormater } from "../../../Directives/us-mobile-formater";
import { MaskedtextPipe } from '../../../Pipes/maskedtext-pipe';
import { NgbDateParserFormatter, NgbDatepickerModule, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DateRangeDirective } from '../../../Directives/date-picker-year-range';
import { DatepickerManualAndCalSelectionDirective } from '../../../Directives/datepicker-manual-and-cal-selection';
import { NoBackNav } from '../../../Directives/no-back-nav';
import { Title } from '@angular/platform-browser';
import { TranslatePipe } from '../../../Pipes/translate-pipe';
import { LanguageSwitch } from '../../sharedComponents/language-switch/language-switch';

@Component({
  selector: 'app-portal-login',
  imports: [ReactiveFormsModule, CommonModule, CountDownPipe, UsMobileFormater, MaskedtextPipe, DatepickerManualAndCalSelectionDirective, NgbDatepickerModule, NoBackNav, TranslatePipe, LanguageSwitch],
  templateUrl: './portal-login.html',
  styleUrl: './portal-login.scss',
  providers: [
    { provide: NgbDateParserFormatter, useClass: MMDDYYYYFormatter }
  ]
})
export class PortalLogin implements OnInit, OnDestroy {
  activeTab: number = 1;
  parentOrganizationId?: number;
  subOrganizationId?: number;
  otpTimerSeconds: number = 0;
  otpIntervalId: any = null;
  selectedType: 'number' | 'email' = 'number';

  userNameNotExist: boolean = false;
  hasUserName: boolean = false;
  isOtpLoading: boolean = false;
  showVerifyButton: Boolean = true;
  showTimer: Boolean = true;
  ResendOtpButton: Boolean = false;
  otpInvalid: Boolean = false;
  ShowMobileScreen: Boolean = false;
  ShowOtpScreen: Boolean = false;
  isOtpLogin: Boolean = false;
  IsSelectEmailOrMobileValidate: Boolean = false;
  otpValidationFailed: Boolean = false;
  isSubmitOtpLoading: Boolean = false;
  isDobMismatch: boolean = false;
  isFirstNameMismatch: boolean = false;
  isLastNameMismatch: boolean = false;
  isMobileMismatch: boolean = false;
  hasUserNameAndDob: boolean = false;
  isItsYouLoading: boolean = false;
  isItsNotYou: boolean = false;
  passwordMismatch: boolean = false;
  hasValuesInInputs: boolean = false;
  chooseAndConfirmLoad: boolean = false;
  credentialsNotValid: boolean = false;
  hasMobileNumber: boolean = false;
  noPatientFound: boolean = false;
  isQrLanding: boolean = false;
  personalDetailsSubmitted: boolean = false;


  private subscriptions = new Subscription();

  //Arrays
  otpKeys: (keyof OtpForm)[] = ['one', 'two', 'three', 'four'];
  allCountries: any[] = [];
  allCountryCodeList: any[] = [];
  NewSignUpPatientList: any[] = [];

  // Objects
  patientDetailsByUserCredentials: any = {};

  private AuthFlowState(): AuthFlowState {
    return {
      isCredentialsFlow: false,
      isSignup: false,
      isLoginWithOtp: false,
      isForgotPassword: false
    }
  }
  authFlowState: AuthFlowState = this.AuthFlowState();

  private SelectedBranchObj(): SelectedBranchObj {
    return {
      Address1: '',
      Address2: '',
      CityId: null,
      CityName: '',
      CountryId: null,
      CountryName: '',
      EmailCommunicationEnabled: false,
      EmailCommunicationProviderId: null,
      HospitalCode: '',
      HospitalContact: '',
      HospitalEmail: '',
      HospitalName: '',
      LocationId: null,
      LocationName: '',
      ParentOrganizationId: null,
      PinCode: '',
      QRImageLogoUrl: '',
      StateId: null,
      StateName: '',
      SubOrganizationId: null,
      SubOrganizationName: ''
    }
  }
  selectedBranchObj: SelectedBranchObj = this.SelectedBranchObj();

  private OrgLogo(): OrgLogo {
    return {
      BrandColor: '',
      ColourBrandingId: null,
      FaviconBase64: '',
      FaviconUrl: '',
      LogoBase64: '',
      LogoFileName: '',
      LogoUrl: '',
      OrganizationId: null,
      PracticeName: '',
      Subtext: '',
      UpdatedBy: null
    }
  }
  orgLogo: OrgLogo = this.OrgLogo();

  credentials = new FormGroup<FormControls<Credentials>>({
    userName: new FormControl('', { nonNullable: true, validators: [Validators.required] }),
    password: new FormControl('', { nonNullable: true, validators: [Validators.required] }),
  });

  verificationMethod = new FormGroup({
    validateOption: new FormControl<'number' | 'email'>('number', { nonNullable: true })
  });

  otpForm = new FormGroup<FormControls<OtpForm>>({
    one: new FormControl('', { nonNullable: true, validators: [Validators.required] }),
    two: new FormControl('', { nonNullable: true, validators: [Validators.required] }),
    three: new FormControl('', { nonNullable: true, validators: [Validators.required] }),
    four: new FormControl('', { nonNullable: true, validators: [Validators.required] }),
  });

  verificationForm = new FormGroup<FormControls<VerificationForm>>({
    CountryCodeforMobile: new FormControl<number | null>(null, { validators: [Validators.required] }),
    Mobileno: new FormControl('', { nonNullable: true, validators: [Validators.required] })
  });

  patientSelectForm = new FormGroup<FormControls<PatientSelectForm>>({
    selectedPatientId: new FormControl<number | null>(null, { validators: [Validators.required] }),
  });

  personalDetailsForm = new FormGroup<FormControls<PersonalDetailsForm>>({
    patientId: new FormControl(0, { nonNullable: true }),
    parentOrganizationId: new FormControl(0, { nonNullable: true }),
    OrganizationId: new FormControl(0, { nonNullable: true }),
    firstName: new FormControl('', { nonNullable: true, validators: [Validators.required] }),
    lastName: new FormControl('', { nonNullable: true, validators: [Validators.required] }),
    dob: new FormControl('', { nonNullable: true, validators: [Validators.required] }),
    phone: new FormControl('', { nonNullable: true, validators: [Validators.required] }),
    gender: new FormControl('', { nonNullable: true }),
    zip: new FormControl('', { nonNullable: true }),
    IsPatientEmailInd: new FormControl(false, { nonNullable: true }),
    IsPatientSmsInd: new FormControl(false, { nonNullable: true })
  });

  chooseAndConfirmPassword = new FormGroup<FormControls<ChooseAndConfirmPassword>>({
    userName: new FormControl('', { nonNullable: true, validators: [Validators.required] }),
    email: new FormControl('', { nonNullable: true, validators: [Validators.email] }),
    password: new FormControl('', { nonNullable: true, validators: [Validators.required, Validators.minLength(8)] }),
    confirmPassword: new FormControl('', { nonNullable: true, validators: [Validators.required] }),
  }, { validators: this.passwordMatchValidator }
  );

  confirmItsYou = new FormGroup<FormControls<ConfirmItsYou>>({
    userName: new FormControl('', { nonNullable: true, validators: [Validators.required] }),
    dob: new FormControl('', { nonNullable: true, validators: [Validators.required] })
  })


  private receiveOtpObj(): ReceiveOtpObject {
    return {
      EmailId: '',
      MobileNo: '',
      CountryCode: '',
      DisplayMobileNo: ''
    }
  };
  ReceivedOtpObj: ReceiveOtpObject = this.receiveOtpObj();

  private otpObj(): OtpObject {
    return {
      one: '',
      two: '',
      three: '',
      four: ''
    }
  };
  OtpObj: OtpObject = this.otpObj();

  private PortalLoginMainObj(): PortalLoginMainObj {
    return {
      Login: {
        activeTab: 0,
        IsShowMultipleSubOrganizationInd: true,
        Mobileno: '',
        email: '',
        CountryCodeforMobile: ''
      }
    };
  };
  portalLoginMainObj: PortalLoginMainObj = this.PortalLoginMainObj();

  private createEmptyPatient(): SelectedPatient {
    return {
      PatientId: null,
      MasterPatientId: null,
      ParentMasterPatientId: null,
      PatientDisplayId: '',
      FirstName: '',
      MiddleName: '',
      LastName: '',
      FullName: '',
      Title: '',
      TitleId: null,
      Gender: null,
      DOB: '',
      Age: 0,
      AgeInYears: 0,
      AgeInMonths: 0,
      AgeInDays: 0,
      MobileNo: '',
      ContactNo: '',
      EmailId: '',
      UserName: '',
      HomeCountryCode: '',
      HomeAreaCode: '',
      HomeNumber: '',
      IsPatientEmailInd: false,
      IsPatientSmsInd: false,
      SSN: '',
      Pincode: '',
      SubOrBranchName: '',
      ImageUrl: ''
    }
  };
  selectedPatient: SelectedPatient = this.createEmptyPatient();

  private PatientForgetpatientobj(): PatientForgetpatientobj {
    return {
      EmailId: '',
      FirstName: '',
      FullName: '',
      HomeAreaCode: '',
      HomeCountryCode: '',
      HomeNumber: '',
      LastName: '',
      MasterPatientId: null,
      MobileNo: '',
      PatientId: null,
      UserName: ''
    }
  }
  patientForgetpatientobj: PatientForgetpatientobj = this.PatientForgetpatientobj();
  private modalService = inject(NgbModal);
  constructor(@Inject(PLATFORM_ID) private platformId: object,
    private route: ActivatedRoute,
    private patientPortal: PatientPortalAPI,
    private portalSessionDataService: PortalSessionDataService,
    private eHnoteParent: Ehnoteparent,
    private portalAuthContextService: PortalAuthContextService,
    private router: Router,
    private portalLogService: PatientPortalLogService,
    private faviconService: FaviconService,
    private title: Title
  ) { };

  @ViewChildren('otpInput') otpInputs!: QueryList<any>;
  @ViewChild('existingAccountModal') existingAccountModal: any;
  @ViewChild('multipleExistingAccountModal') multipleExistingAccountModal: any;

  ngOnInit() {
    const hospitalContext = this.portalSessionDataService.getSignal<any>(
      SESSION_KEYS.HOSPITAL_CONTEXT
    );

    const isQrLandingSignal = this.portalSessionDataService.getSignal<boolean>(
      SESSION_KEYS.IS_QR_LANDING
    );
    this.isQrLanding = isQrLandingSignal() ?? false;

    const context = hospitalContext();

    this.parentOrganizationId =
      context?.HospitalId ??
      context[0]?.HospitalInfo?.HospitalDetails?.ParentOrganizationId;

    this.subOrganizationId =
      context[0]?.HospitalInfo?.HospitalDetails?.SubOrganizationId;

    // this.parentOrganizationId = Number(this.route.snapshot.queryParamMap.get('porid'));
    this.getOrgLogoByOrgId();
    this.getParentSubOrganizationIdByBranchId();
    this.getCountries();
    this.verificationMethod.get('validateOption')!.valueChanges.subscribe(value => {
      this.selectedType = value;
    });
    this.personalDetailsForm.get('dob')?.valueChanges.subscribe(() => {
      this.isDobMismatch = false;
    });

    this.confirmItsYou.controls.userName.valueChanges.subscribe(() => {
      this.userNameNotExist = false;
    });

    this.credentials.valueChanges.subscribe(() => {
      this.hasUserName = false;
      this.userNameNotExist = false;
      this.credentialsNotValid = false;
    });

    this.verificationForm.valueChanges.subscribe(() => {
      this.hasMobileNumber = false;
      this.noPatientFound = false;
    });

    this.chooseAndConfirmPassword.controls.confirmPassword.valueChanges.subscribe(() => {
      this.passwordMismatch = false;
    });

    this.personalDetailsForm.valueChanges.subscribe(() => {
      this.isFirstNameMismatch = false;
      this.isLastNameMismatch = false;
      this.isDobMismatch = false;
      this.isMobileMismatch = false;
    });

  }

  private getLogContext() {
    return {
      patientId: this.patientDetailsByUserCredentials?.PatientId || null,
      appointmentId: null,
      hospitalId: this.parentOrganizationId || 0
    };
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  setActiveTab(tab: number) {
    this.activeTab = tab;
  }

  nextTab(type: string) {
    const MAX_TAB = 10;
    switch (type) {
      case 'back':
        this.resetTabData(this.activeTab);
        return;

      case 'validateCredentials':
        this.validateCredentials();
        return;

      case 'sendOtp':
        this.onSendOtp();
        return;

      case 'verifyOTP':
        this.validateOtp();
        return;

      //signup flow
      case 'signUp':
        this.authFlowState.isSignup = true;
        this.setActiveTab(4)
        return;

      case 'backToLogin':
        this.resetAllFormsAndState();
        this.setActiveTab(1);
        return;

      case 'PatentSelection':
        if (this.authFlowState.isSignup) {
          if (this.selectedPatient.UserName) {
            this.openMultipleExistingAccountModal();
            return;
          }
          this.setActiveTab(6);
          this.patchPersonalDetails();
        } else {
          if (!this.selectedPatient.UserName) {
            this.setActiveTab(1);
            console.error('patient does not have a username');
            return;
          }
          this.confirmItsYou.patchValue({
            userName: this.selectedPatient.UserName
          })
          this.setActiveTab(8);
        }
        return;

      case 'isValidPatientOrNot':
        this.isValidPatientOrNot();
        return;

      case 'AddUpdatePatientSignUp':
        this.checkForgotOrAddUpdate();
        return;

      //login with OTP
      case 'loginWithOtp':
        this.GetValidatePatientPortalCredentials();
        return;

      //forgot password
      case 'forgotPassword':
        this.authFlowState.isForgotPassword = true;
        this.setActiveTab(4)
        return;

      case 'confirmItsYou':
        this.GetValidatePatientPortalCredentials();
        return;
    }
    if (this.activeTab < MAX_TAB) this.setActiveTab(this.activeTab + 1);
  }


  //Getter (Accessor) Methods or Class Getter Properties
  get isBrowser() {
    return isPlatformBrowser(this.platformId);
  }

  get isSignupFlow(): boolean {
    return this.authFlowState.isSignup;
  }




  //Helper functions

  getOrgLogoByOrgId() {
    if (!this.parentOrganizationId) return;

    this.subscriptions.add(
      this.patientPortal.getOrgLogoByOrganizationId(this.parentOrganizationId).subscribe({
        next: (resp: any) => {
          if (resp.Status === 'Success' && resp.rows.length > 0) {
            this.orgLogo = { ...resp.rows[0] };
            if (this.orgLogo?.FaviconUrl) {
              this.faviconService.setFavicon(this.orgLogo.FaviconUrl);
            }
            this.portalSessionDataService.set(SESSION_KEYS.PORTAL_BRANDING, resp.rows[0]);
          }
        },
        error: (err: any) => {
          console.error('Error while getting organization Logo', err);
        },
      })
    )
  }

  getParentSubOrganizationIdByBranchId() {
    if (!this.parentOrganizationId) return;
    this.subscriptions.add(
      this.patientPortal.getParentSubOrganizationIdByBranchId(this.parentOrganizationId).subscribe({
        next: (resp: any) => {
          if (resp.status === 'Success') {
            this.selectedBranchObj = { ...resp };
            this.portalSessionDataService.set(SESSION_KEYS.HOSPITAL_PROFILE, resp);
          }
        },
        error: (err: any) => {
          console.error('Error while getting parent sub organization id`s by branch id', err);
        },
      })
    )
  }

  getCountries() {
    this.subscriptions.add(
      this.patientPortal.getCountries().subscribe({
        next: (resp: any) => {
          if (resp) {
            this.allCountries = resp ?? [];
            this.allCountryCodeList = this.allCountries.filter(
              country => country.InternationalDialing?.trim()
            );
            this.portalSessionDataService.set(SESSION_KEYS.COUNTRY_LIST, resp);
            this.setDefaultCountryCode();
          }
        },
        error: (err: any) => {
          console.error('Error while getting counties list', err);
        },
      })
    )
  }

  setDefaultCountryCode() {
    const usCountry = this.allCountryCodeList.find(
      c => c.CountryCode === 'US' || c.InternationalDialing === '+1'
    );

    if (usCountry) {
      this.verificationForm.patchValue({
        CountryCodeforMobile: usCountry.Id
      });
    }
  }

  private getCountryCodeFromId(id: number | null): string {
    return (
      this.allCountryCodeList.find(c => c.Id === id)?.InternationalDialing || '+1'
    );
  }










  //User credentials validation( UserName and Password) start
  validateCredentials() {
    if (this.credentials.invalid) {
      this.hasUserName = true;
      this.credentials.markAllAsTouched();
      return;
    }

    this.isOtpLoading = true;
    const params = {
      UserId: 1,
      HospitalId: this.parentOrganizationId || 0,
      EmailId: this.credentials.value.userName || '',
      Password: this.credentials.value.password || ''
    }

    this.subscriptions.add(
      this.patientPortal.validatePatientLogin(params).subscribe({
        next: (resp: any) => {
          if (resp.Status === 'Success') {
            this.authFlowState.isCredentialsFlow = true;
            this.isOtpLoading = false;
            this.ReceivedOtpObj.MobileNo = MobileNoUtil.normalizeUS(resp.rows[0].MobileNumber);
            this.ReceivedOtpObj.EmailId = resp.rows[0].EmailId;
            this.patientDetailsByUserCredentials = resp.rows[0];
            this.portalSessionDataService.set(SESSION_KEYS.PORTAL_USER_DETAILS, resp.rows[0]);
            this.portalSessionDataService.set(SESSION_KEYS.LOGIN__USERNAME, resp.rows[0].MasterUserName[0].UserName);
            this.setDefaultVerificationMethod(resp.rows[0]);
            this.portalLogService.addUpdateLog(this.getLogContext(), 5, 'Patient Login Credentials Validated Successfully');
            if (!this.noContactAvailable) {
              this.setActiveTab(2);
            }
          } else {
            this.credentialsNotValid = true;
            this.isOtpLoading = false;
            this.portalLogService.addUpdateLog(this.getLogContext(), 5, 'Patient Login Credentials Validation Failed');
          }
        },
        error: (err: any) => {
          this.isOtpLoading = false;
          this.credentialsNotValid = true;
          console.error('Error while validate the credentials', err);
        }
      })
    );
  }

  hasEmail: boolean = false;
  hasMobile: boolean = false;
  noContactAvailable: boolean = false; // ✅ Add this new flag

  setDefaultVerificationMethod(patientDetails: any): void {
    this.hasMobile = !!(patientDetails.MobileNumber?.trim()) &&
      patientDetails.MobileNumber.trim().replace(/\D/g, '').length > 1;

    this.hasEmail = !!(patientDetails.EmailId?.trim());

    this.noContactAvailable = !this.hasMobile && !this.hasEmail;

    if (this.hasMobile) {
      this.verificationMethod.get('validateOption')?.setValue('number');
    } else if (this.hasEmail) {
      this.verificationMethod.get('validateOption')?.setValue('email');
    } else {
      this.verificationMethod.get('validateOption')?.setValue('' as any);
    }
  }

  onSendOtp() {
    this.isOtpLoading = true;
    if (this.selectedType === 'number') {
      this.generateOtpForPatient();
    }
    else if (this.selectedType === 'email') {
      this.generateOtpForPatientOnEmail();
    }
    else {
      return;
    }
  }


  generateOtpForPatientOnEmail(resend?: 'resend') {
    const patinetDetails = this.patientDetailsByUserCredentials;
    const mobileNumber = MobileNoUtil.normalizeUS(patinetDetails.MobileNumber || '');
    const reqobj = {
      MobileNumber: mobileNumber,
      EmailId: patinetDetails.EmailId?.toString() || '',
      CountryCodeforMobile: patinetDetails.CountryCodeforMobile,
      patientid: patinetDetails.PatientId,
      EmailCommunicationProviderId: this.selectedBranchObj?.EmailCommunicationProviderId || 0,
      EmailCommunicationEnabled: this.selectedBranchObj?.EmailCommunicationEnabled || false,
      HospitalID: patinetDetails?.OrganizationId ?? this.parentOrganizationId ?? 0,
      PatientName: patinetDetails.FullName || '',
      OrganizationName: patinetDetails?.OrganizationName || '',
    };

    this.subscriptions.add(
      this.eHnoteParent.GenerateOtpForPatientPortalToEmail(reqobj).subscribe({
        next: (data: any) => {
          this.isOtpLoading = false;
          const resp = data?.data ?? data;
          if (resp?.Status === 'Success') {
            // if (!resp.IsPatientsExist) {
            //   this.noPatientAvailable = true;
            //   this.cd.detectChanges();
            //   return;
            // }
            this.setActiveTab(3);
            this.ReceivedOtpObj.MobileNo = '';
            this.ReceivedOtpObj.EmailId = resp?.EmailId ?? '';
            this.setupOtpUI(resend);
            const acd = resend === 'resend'
              ? 'Login Validation OTP ReSent(Email)'
              : 'Login Validation OTP Sent(Email)';
            this.portalLogService.addUpdateLog(this.getLogContext(), 5, acd);
          } else {
            console.error(resp?.Message || 'OTP generation failed');
            this.portalLogService.addUpdateLog(this.getLogContext(), 5, 'Login Validation OTP Sending Failed(Email)');
          }
        },
        error: (err) => {
          this.isOtpLoading = false;
          console.error('GenerateOtpForPatientPortalToEmail error', err);
        }
      })
    );
  }

  generateOtpForPatient(resend?: 'resend') {
    let mobileNumber = '';
    let countryCode = '';
    let patientId = '';
    let orgName = '';

    if (this.authFlowState.isCredentialsFlow || this.authFlowState.isLoginWithOtp) {
      const p = this.patientDetailsByUserCredentials;
      mobileNumber = MobileNoUtil.normalizeUS(p.MobileNumber ?? p.MobileNo ?? '');
      patientId = p.PatientId || '';
      orgName = p.OrganizationName ?? this.selectedBranchObj.HospitalName ?? '';
      countryCode = MobileNoUtil.extractCountryCode(p.MobileNumber ?? p.MobileNo ?? '');

    } else if (this.authFlowState.isSignup) {
      if (this.verificationForm.value.Mobileno?.length !== 14) {
        this.hasMobileNumber = true;
        this.isOtpLoading = false;
        this.credentials.markAllAsTouched();
        return;
      }
      const form = this.verificationForm.value;
      const countryCodeForMobileNum = Number(form.CountryCodeforMobile);
      mobileNumber = MobileNoUtil.normalizeUS(form.Mobileno || '');
      countryCode = this.getCountryCodeFromId(countryCodeForMobileNum || null);
      orgName = this.selectedBranchObj.HospitalName ?? '';

    } else if (this.authFlowState.isForgotPassword) {
      if (this.verificationForm.value.Mobileno?.length !== 14) {
        this.hasMobileNumber = true;
        this.isOtpLoading = false;
        this.credentials.markAllAsTouched();
        return;
      }
      const form = this.verificationForm.value;
      const countryCodeForMobileNum = Number(form.CountryCodeforMobile);
      mobileNumber = MobileNoUtil.normalizeUS(form.Mobileno || '');
      countryCode = this.getCountryCodeFromId(countryCodeForMobileNum || null);
      orgName = this.selectedBranchObj.HospitalName ?? '';
    } else {
      return;
    }

    const reqobj = {
      MobileNumber: mobileNumber,
      EmailId: '',
      CountryCode: countryCode,
      patientid: patientId,
      OrganizationName: orgName
    };

    this.subscriptions.add(
      this.eHnoteParent.GenerateOtpForPatientPortal(reqobj).subscribe({
        next: (data: any) => {
          this.isOtpLoading = false;

          const resp = data?.data ?? data;

          if (resp?.Status === 'Success' && resp?.IsPatientsExist === true) {
            this.setActiveTab(3);
            this.ReceivedOtpObj.EmailId = '';
            this.ReceivedOtpObj.MobileNo = resp?.MobileNumber ?? '';
            this.setupOtpUI(resend);
            const acd = resend === 'resend'
              ? 'Login Validation OTP ReSent(Mobile)'
              : 'Login Validation OTP Sent(Mobile)';
            this.portalLogService.addUpdateLog(this.getLogContext(), 5, acd);
          } else {
            this.noPatientFound = true;
            this.portalLogService.addUpdateLog(this.getLogContext(), 5, 'Login Validation OTP Sending Failed(Mobile)');
          }
        },
        error: (err) => {
          this.isOtpLoading = false;
          this.noPatientFound = true;
          console.error('GenerateOtpForPatientPortal error', err);
        }
      })
    );
  }
  //User credentials validation( UserName and Password) end















  //OTP Screen start

 selectInput(event: FocusEvent): void {
  const input = event.target as HTMLInputElement;
  input.select();
}

moveNext(event: Event, index: number): void {
  const input = event.target as HTMLInputElement;

  input.value = input.value.replace(/\D/g, '').slice(0, 1);

  if (input.value && index < this.otpInputs.length - 1) {
    this.otpInputs.toArray()[index + 1].nativeElement.focus();
  }
}

  movePrev(event: KeyboardEvent, index: number) {
    if (event.key !== 'Backspace') return;

    const currentKey = this.otpKeys[index];
    const currentValue = this.otpForm.controls[currentKey].value;

    if (!currentValue && index > 0) {
      const prevInput = this.otpInputs.toArray()[index - 1];
      prevInput.nativeElement.focus();
    }
  }

  private setupOtpUI(resend?: 'resend') {
    this.stopOtpTimer();
    this.OtpObj = { one: '', two: '', three: '', four: '' };
    this.otpForm.reset();
    this.otpInvalid = false;
    this.showVerifyButton = true;
    this.showTimer = true;
    this.ShowMobileScreen = false;
    this.ShowOtpScreen = true;
    this.isOtpLogin = true;
    this.ResendOtpButton = false;
    this.IsSelectEmailOrMobileValidate = false;
    // this.noPatientAvailable = false;
    this.otpValidationFailed = false;
    if (this.isBrowser) this.startOtpTimer(180);
  }

  private startOtpTimer(totalSeconds: number) {
    if (!this.isBrowser) return;
    this.stopOtpTimer();
    this.otpTimerSeconds = totalSeconds;
    this.showVerifyButton = true;
    this.showTimer = true;
    this.otpIntervalId = setInterval(() => {
      this.otpTimerSeconds--;
      if (this.otpTimerSeconds <= 0) {
        this.stopOtpTimer();
        this.showVerifyButton = false;
        this.showTimer = false;
        this.ResendOtpButton = true;
      }
    }, 1000);
  }

  private stopOtpTimer() {
    if (this.otpIntervalId) clearInterval(this.otpIntervalId);
    this.otpIntervalId = null;
  }

  resendOtp() {
    this.setupOtpUI();
    if (this.selectedType === 'number') {
      this.generateOtpForPatient('resend');
    } else if (this.selectedType === 'email') {
      this.generateOtpForPatientOnEmail('resend');
    }
    this.focusFirstOtpInput();
  }

  ngAfterViewInit() {
    this.otpInputs.changes.subscribe(() => {
      this.focusFirstOtpInput();
    });
  }

  private focusFirstOtpInput() {
    if (!this.isBrowser) return;
    setTimeout(() => {
      const first = this.otpInputs?.first;
      first?.nativeElement?.focus();
    }, 0);
  }

  validateOtp() {
    this.isSubmitOtpLoading = true;
    this.OtpObj = this.otpForm.value as OtpObject;
    const otp = Object.values(this.OtpObj).join('');

    let mobileNumber = '';
    let email = '';

    if (this.authFlowState.isCredentialsFlow || this.authFlowState.isLoginWithOtp) {
      const p = this.patientDetailsByUserCredentials;
      mobileNumber = MobileNoUtil.normalizeUS(p.MobileNumber ?? p.MobileNo ?? '');
      email = p.EmailId || '';

    } else if (this.authFlowState.isSignup || this.authFlowState.isForgotPassword) {
      const form = this.verificationForm.value;
      mobileNumber = MobileNoUtil.normalizeUS(form.Mobileno || '');
    }

    if (this.isQrLanding && !this.authFlowState.isSignup && !this.authFlowState.isForgotPassword) {
      const mobileOtpReq = {
        reqMobileNo: mobileNumber,
        Otp: otp,
        ParentOrganizationId: this.parentOrganizationId ?? 0
      };

      const emailOtpReq = {
        reqEmail: email,
        Otp: otp,
        ParentOrganizationId: this.parentOrganizationId ?? 0,
      };

      if (this.selectedType === 'number') {
        this.subscriptions.add(
          this.patientPortal.ValidatePatientQRAppOTP(mobileOtpReq).subscribe({
            next: (data: any) => {
              const resp = data?.data ?? data;
              if ((resp?.status ?? resp?.Status) === 'Success') {
                this.stopOtpTimer();
                this.portalLogService.addUpdateLog(this.getLogContext(), 5, 'Login OTP Validated Successfully(Mobile)');
                if (this.authFlowState.isCredentialsFlow || this.authFlowState.isLoginWithOtp) {
                  const rows = resp?.rows || [];

                  const matchedUser = rows.find(
                    (x: any) =>
                      x.PatientId === this.patientDetailsByUserCredentials?.PatientId
                  );

                  if (matchedUser) {
                    this.portalSessionDataService.set(
                      SESSION_KEYS.PORTAL_USER_DETAILS,
                      matchedUser
                    );
                  }

                  this.portalAuthContextService.setPortalLoginSuccess();
                  this.addLoginDevice(this.patientDetailsByUserCredentials?.PatientId);
                  // ✅ Fix 1
                  this.router.navigate(['/patientPortal', 'dashboard']).then(() => {
                    this.isSubmitOtpLoading = false;
                  });
                } else {
                  const patientCount = resp.rows?.length ?? 0;
                  if (this.authFlowState.isForgotPassword) {

                    if (patientCount > 1) {
                      this.NewSignUpPatientList = resp.rows || [];
                      if (this.selectedType === 'number') {
                        this.personalDetailsForm.get('phone')?.disable();
                      } else {
                        this.personalDetailsForm.get('Email')?.disable();
                      }
                      this.isSubmitOtpLoading = false;
                      this.setActiveTab(5);
                      return;
                    }

                    if (patientCount === 1) {
                      this.selectedPatient = resp.rows[0];
                      if (this.selectedPatient?.UserName) {
                        this.confirmItsYou.patchValue({ userName: this.selectedPatient.UserName });
                        this.isSubmitOtpLoading = false;
                        this.setActiveTab(8);
                      } else {
                        this.isSubmitOtpLoading = false;
                        this.resetAllFormsAndState();
                        this.setActiveTab(1);
                        console.error('No username associated with this account. Please signup first.');
                      }
                    } else {
                      this.isSubmitOtpLoading = false;
                      this.otpInvalid = true;
                      this.otpForm.reset();
                      this.focusFirstOtpInput();
                    }

                  } else {
                    this.NewSignUpPatientList = resp.rows || [];
                    this.personalDetailsForm.get('phone')?.disable();
                    this.isSubmitOtpLoading = false;
                    this.setActiveTab(5);
                  }
                }
              } else {
                this.isSubmitOtpLoading = false;
                this.otpInvalid = true;
                this.otpForm.reset();
                this.focusFirstOtpInput();
                this.portalLogService.addUpdateLog(this.getLogContext(), 5, 'User Login Failed');
              }
            },
            error: (err: any) => {
              this.isSubmitOtpLoading = false;
              this.otpValidationFailed = true;
              this.otpForm.reset();
              this.focusFirstOtpInput();
            },
          })
        );
      } else {
        this.subscriptions.add(
          this.eHnoteParent.ValidatePatientQRAppOTPToEmailId(emailOtpReq).subscribe({
            next: (data: any) => {
              const resp = data?.data ?? data;
              if ((resp?.status ?? resp?.Status) === 'Success') {
                this.stopOtpTimer();
                this.portalLogService.addUpdateLog(this.getLogContext(), 5, 'Login OTP Validated Successfully(Email)');
                if (this.authFlowState.isCredentialsFlow || this.authFlowState.isLoginWithOtp) {
                  const rows = resp?.rows || [];

                  const matchedUser = rows.find(
                    (x: any) =>
                      x.PatientId === this.patientDetailsByUserCredentials?.PatientId
                  );

                  if (matchedUser) {
                    this.portalSessionDataService.set(
                      SESSION_KEYS.PORTAL_USER_DETAILS,
                      matchedUser
                    );
                  }
                  this.portalAuthContextService.setPortalLoginSuccess();
                  this.addLoginDevice(this.patientDetailsByUserCredentials?.PatientId);
                  // ✅ Fix 2
                  this.router.navigate(['/patientPortal', 'dashboard']).then(() => {
                    this.isSubmitOtpLoading = false;
                  });
                } else {
                  const patientCount = resp.rows?.length ?? 0;
                  if (patientCount === 1 || patientCount === 0) {
                    if (this.authFlowState.isForgotPassword) {
                      this.selectedPatient = resp.rows[0];
                      if (this.selectedPatient.UserName) {
                        this.confirmItsYou.patchValue({
                          userName: this.selectedPatient.UserName
                        });
                        this.isSubmitOtpLoading = false;
                        this.setActiveTab(8);
                      } else {
                        this.isSubmitOtpLoading = false;
                        this.resetAllFormsAndState();
                        this.setActiveTab(1);
                        console.error('No username associated with this account. Please signup first.');
                      }

                    } else {
                      this.NewSignUpPatientList = [];
                      this.selectedPatient = resp.rows[0];
                      if (this.selectedPatient?.UserName) {
                        this.isSubmitOtpLoading = false;
                        this.openExistingAccountModal();
                        return;
                      }
                      this.personalDetailsForm.get('Email')?.disable();
                      this.personalDetailsForm.patchValue({
                        IsPatientEmailInd: Boolean(this.selectedPatient?.IsPatientEmailInd || true),
                        IsPatientSmsInd: Boolean(this.selectedPatient?.IsPatientSmsInd || true)
                      });
                      this.isSubmitOtpLoading = false;
                      this.setActiveTab(6);
                      this.patchPersonalDetails();
                    }
                  } else {
                    this.NewSignUpPatientList = resp.rows || [];
                    this.personalDetailsForm.get('Email')?.disable();
                    this.isSubmitOtpLoading = false;
                    this.setActiveTab(5);
                  }
                }
              } else {
                this.isSubmitOtpLoading = false;
                this.otpInvalid = true;
                this.otpForm.reset();
                this.focusFirstOtpInput();
                this.portalLogService.addUpdateLog(this.getLogContext(), 5, 'User Login Failed');
              }
            },
            error: (err: any) => {
              this.isSubmitOtpLoading = false;
              this.otpValidationFailed = true;
              this.otpForm.reset();
              this.focusFirstOtpInput();
            },
          })
        );
      }
    }

    if (!this.isQrLanding || (this.isQrLanding && (this.authFlowState.isSignup || this.authFlowState.isForgotPassword))) {
      const mobileOtpReq = {
        reqMobileNo: mobileNumber,
        Otp: otp,
        SubOrganizationId: this.subOrganizationId ?? 0
      };
      this.subscriptions.add(
        this.patientPortal.ValidatePatientAppOTP(mobileOtpReq).subscribe({
          next: (data: any) => {
            const resp = data?.data ?? data;
            if ((resp?.status ?? resp?.Status) === 'Success') {
              this.stopOtpTimer();
              this.portalLogService.addUpdateLog(this.getLogContext(), 5, 'Login OTP Validated Successfully(Mobile)');

              if (this.authFlowState.isCredentialsFlow || this.authFlowState.isLoginWithOtp) {
                if (this.authFlowState.isLoginWithOtp) {
                  this.portalSessionDataService.set(SESSION_KEYS.PORTAL_USER_DETAILS, resp.rows[0]);
                }
                this.portalAuthContextService.setPortalLoginSuccess();
                this.addLoginDevice(this.patientDetailsByUserCredentials?.PatientId);
                // ✅ Fix 3
                this.router.navigate(['/patientPortal', 'dashboard']).then(() => {
                  this.isSubmitOtpLoading = false;
                });
                return;
              }

              const patientList = resp.rows || [];

              if (this.authFlowState.isForgotPassword) {

                if (patientList.length > 1) {
                  this.NewSignUpPatientList = patientList;
                  this.personalDetailsForm.get('phone')?.disable();
                  this.isSubmitOtpLoading = false;
                  this.setActiveTab(5);
                  return;
                }

                if (patientList.length === 1) {
                  this.selectedPatient = patientList[0];
                  if (this.selectedPatient?.UserName) {
                    this.confirmItsYou.patchValue({ userName: this.selectedPatient.UserName });
                    this.isSubmitOtpLoading = false;
                    this.setActiveTab(8);
                  } else {
                    this.isSubmitOtpLoading = false;
                    this.resetAllFormsAndState();
                    this.setActiveTab(1);
                    console.error('No username associated with this account. Please signup first.');
                  }
                } else {
                  this.isSubmitOtpLoading = false;
                  this.otpInvalid = true;
                  this.otpForm.reset();
                  this.focusFirstOtpInput();
                }

                return;
              }

              if (patientList.length === 0) {
                this.NewSignUpPatientList = [];
                this.isSubmitOtpLoading = false;
                this.setActiveTab(6);
                this.patchPersonalDetails();

              } else if (patientList.length === 1) {
                this.selectedPatient = patientList[0];

                if (this.selectedPatient?.UserName) {
                  this.isSubmitOtpLoading = false;
                  this.openExistingAccountModal();
                  return;
                }

                this.personalDetailsForm.get('phone')?.disable();
                this.personalDetailsForm.patchValue({
                  IsPatientEmailInd: Boolean(this.selectedPatient?.IsPatientEmailInd || true),
                  IsPatientSmsInd: Boolean(this.selectedPatient?.IsPatientSmsInd || true)
                });
                this.isSubmitOtpLoading = false;
                this.setActiveTab(6);
                this.patchPersonalDetails();

              } else {
                this.NewSignUpPatientList = patientList;
                this.personalDetailsForm.get('phone')?.disable();
                this.isSubmitOtpLoading = false;
                this.setActiveTab(5);
              }

            } else {
              this.isSubmitOtpLoading = false;
              this.otpInvalid = true;
              this.otpForm.reset();
              this.focusFirstOtpInput();
              this.portalLogService.addUpdateLog(this.getLogContext(), 5, 'Invalid Login OTP Entered (Mobile)');
            }
          },
          error: (err: any) => {
            this.isSubmitOtpLoading = false;
            this.otpValidationFailed = true;
            this.otpForm.reset();
            this.focusFirstOtpInput();
            this.portalLogService.addUpdateLog(this.getLogContext(), 5, 'Login OTP Validation Failed(Mobile)');
          }
        })
      );
    }
  }
  //OTP screen end

  //New
  openExistingAccountModal() {
    this.modalService.open(this.existingAccountModal, {
      centered: true,
      backdrop: 'static',
      size: 'md'
    });
  }

  continueToLogin(modal: any) {
    modal.close();
    this.resetAllFormsAndState();
    this.setActiveTab(1);
  }

  moveToConfirmItsYou(modal: any, item: SelectedPatient) {
    modal.close();
    this.authFlowState.isForgotPassword = true;
    this.confirmItsYou.patchValue({
      userName: item.UserName
    });
    this.setActiveTab(8);
  }

  openMultipleExistingAccountModal() {
    this.modalService.open(this.multipleExistingAccountModal, {
      centered: true,
      backdrop: 'static',
      size: 'md'
    });
  }

  choosediffPatient(modal: any) {
    modal.close();
    this.setActiveTab(5);
  }
  //New
















  //New User SignUp

  onSelectPatient(patient: SelectedPatient) {
    this.selectedPatient = { ...this.createEmptyPatient(), ...patient };
    this.personalDetailsForm.patchValue({
      IsPatientEmailInd: !!patient.IsPatientEmailInd,
      IsPatientSmsInd: !!patient.IsPatientSmsInd
    });
    const pid = this.selectedPatient.PatientId ?? null;
    this.patientSelectForm.patchValue({ selectedPatientId: pid });

    this.chooseAndConfirmPassword.patchValue({
      email: patient.EmailId ?? ''
    });
  }

  private patchPersonalDetails() {
    const formattedMobileNumber = MobileNoUtil.normalizeUS(this.verificationForm.value.Mobileno)
    const mobileFromPatient = MobileNoUtil.normalizeUS(this.selectedPatient?.MobileNo);
    const UsFormatMobileNumber = MobileNoUtil.usMobileFormatChange(mobileFromPatient);
    this.personalDetailsForm.patchValue({
      firstName: this.selectedPatient?.FirstName ?? '',
      lastName: this.selectedPatient?.LastName ?? '',
      dob: '',
      phone: UsFormatMobileNumber.UsFormatMobileNumber ?? formattedMobileNumber ?? '',
      gender: this.selectedPatient?.Gender ?? '',
      zip: this.selectedPatient?.Pincode ?? ''
    });

    (['firstName', 'lastName', 'gender'] as const).forEach(key => {
      const control = this.personalDetailsForm.get(key);
      const value = control?.value;
      if (value != null && String(value).trim() !== '') {
        control?.disable();
      } else {
        control?.enable();
      }
    });

    this.chooseAndConfirmPassword.patchValue({
      email: this.selectedPatient?.EmailId ?? ''
    });
  }

  private passwordMatchValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const password = control.get('password')?.value;
      const confirm = control.get('confirmPassword')?.value;

      if (!password || !confirm) {
        return null;
      }

      return password === confirm ? null : { passwordMismatch: true };
    };
  }

  isValidPatientOrNot() {
    if (this.personalDetailsForm.invalid) {
      this.personalDetailsSubmitted = true;
      this.personalDetailsForm.markAllAsTouched();
      return;
    }
    this.personalDetailsSubmitted = false;
    this.isFirstNameMismatch = false;
    this.isLastNameMismatch = false;
    this.isDobMismatch = false;
    this.isMobileMismatch = false;

    const form = this.personalDetailsForm.getRawValue();

    const enteredFirstName = (form.firstName || '').trim().toLowerCase();
    const enteredLastName = (form.lastName || '').trim().toLowerCase();
    const enteredDob = DateUtil.toYMD(form.dob);
    const enteredMobile = MobileNoUtil.normalizeUS(form.phone || '');

    const patient = this.selectedPatient;

    const patientFirstName = (patient?.FirstName || '').trim().toLowerCase();
    const patientLastName = (patient?.LastName || '').trim().toLowerCase();
    const patientDob = patient?.DOB ? DateUtil.toYMD(patient.DOB) : null;
    const patientMobile = patient?.MobileNo
      ? MobileNoUtil.normalizeUS(patient.MobileNo)
      : null;

    if (patientFirstName && enteredFirstName !== patientFirstName) {
      this.isFirstNameMismatch = true;
    }

    if (patientLastName && enteredLastName !== patientLastName) {
      this.isLastNameMismatch = true;
    }

    if (patientDob && enteredDob !== patientDob) {
      this.isDobMismatch = true;
    }

    if (patientMobile && enteredMobile !== patientMobile) {
      this.isMobileMismatch = true;
    }

    if (
      this.isFirstNameMismatch ||
      this.isLastNameMismatch ||
      this.isDobMismatch ||
      this.isMobileMismatch
    ) {
      return;
    }

    this.setActiveTab(7);
  }

  checkForgotOrAddUpdate() {
    this.chooseAndConfirmLoad = true;
    this.hasValuesInInputs = false;
    if (!this.authFlowState.isSignup) {
      this.chooseAndConfirmPassword.controls.email.clearValidators();
      this.chooseAndConfirmPassword.controls.email.updateValueAndValidity();
      this.chooseAndConfirmPassword.controls.userName.clearValidators();
      this.chooseAndConfirmPassword.controls.userName.updateValueAndValidity();
    }
    if (this.chooseAndConfirmPassword.invalid) {
      this.hasValuesInInputs = true;
      this.chooseAndConfirmPassword.markAllAsTouched();
      this.chooseAndConfirmLoad = false;
      return;
    }

    if (this.chooseAndConfirmPassword.value.password !== this.chooseAndConfirmPassword.value.confirmPassword) {
      this.passwordMismatch = true;
      this.chooseAndConfirmLoad = false;
      return;
    }

    if (this.authFlowState.isSignup) {
      this.addupdatePatientSignUp();
    } else {
      this.UpdatePatientForgotPassword();
    }
  }

  addupdatePatientSignUp() {
    const form = this.chooseAndConfirmPassword.getRawValue();
    const personal = this.personalDetailsForm.getRawValue();

    const param = {
      UserId: 1,
      HospitalId: this.parentOrganizationId || 1,
      PatientId: this.selectedPatient?.PatientId || 0,
      FirstName: personal.firstName,
      MiddleName: '',
      LastName: personal.lastName,
      DOB: DateUtil.toYMD(personal.dob),
      Gender: personal.gender,
      EmailId: form.email,
      Password: form.password,
      HomeCountryCode: MobileNoUtil.extractCountryCode(this.selectedPatient?.MobileNo),
      HomeAreaCode: MobileNoUtil.extractAreaCode(this.selectedPatient?.MobileNo),
      HomeNumber: MobileNoUtil.extractLastSevenDigits(this.selectedPatient?.MobileNo),
      MobileNumber: MobileNoUtil.normalizeUS(personal.phone),
      Pincode: personal.zip || '',
      Username: form.userName,
      MasterPatientId: this.selectedPatient?.MasterPatientId || null,
      IsEdit: false
    };

    this.subscriptions.add(
      this.patientPortal.USAddUpdatePatientSignUp(param).subscribe({
        next: (resp: any) => {
          if (resp?.Status === 'Success') {
            this.chooseAndConfirmLoad = false;
            this.portalLogService.addUpdateLog(this.getLogContext(), 5, 'New Patient SignUp Completed Successfully');
            this.authFlowState = this.AuthFlowState();
            this.setActiveTab(1);
          } else {
            this.chooseAndConfirmLoad = false;
            this.chooseAndConfirmPassword
              .get('userName')
              ?.setErrors({ alreadyExists: true });
          }
        },
        error: () => {
          this.chooseAndConfirmLoad = false;
          this.chooseAndConfirmPassword
            .get('userName')
            ?.setErrors({ serverError: true });
        }
      })
    );
  }


  UpdatePatientForgotPassword() {
    this.hasValuesInInputs = false;
    const form = this.chooseAndConfirmPassword.getRawValue();

    const param = {
      UserName: form.userName,
      PatientId: this.selectedPatient?.PatientId || 0,
      Password: form.password,
      HospitalId: this.parentOrganizationId || null
    };

    this.subscriptions.add(
      this.patientPortal.AddUpdatePatientPassword(param).subscribe({
        next: (resp: any) => {
          if (resp?.Status === 'Success') {
            this.chooseAndConfirmLoad = false;
            this.portalLogService.addUpdateLog(this.getLogContext(), 5, 'Patient Password Updated Successfully');
            this.authFlowState = this.AuthFlowState();
            this.setActiveTab(1);
          } else {
            this.chooseAndConfirmLoad = false;
            console.error(`Password Updation  Failed For UserName: ${form.userName}`)
          }
        },
        error: (err) => {
          this.chooseAndConfirmLoad = false;
          console.error('Error white update the password', err);
        }
      })
    );
  }



  //Login With OTP
  GetValidatePatientPortalCredentials() {
    if (!this.authFlowState.isForgotPassword && this.credentials.controls.userName.invalid) {
      this.hasUserName = true;
      this.credentials.controls.userName.markAsTouched();
      return;
    }

    if (this.authFlowState.isForgotPassword && this.confirmItsYou.invalid) {
      this.hasUserNameAndDob = true;
      this.confirmItsYou.markAsTouched();
      return;
    }

    if (this.authFlowState.isForgotPassword) {
      this.hasUserNameAndDob = false;
    } else {
      this.setActiveTab(2);
      this.hasUserName = false;
    }

    this.isItsYouLoading = true;
    const userName = this.authFlowState.isForgotPassword ? this.confirmItsYou.controls.userName.value : this.credentials.controls.userName.value;
    const param = {
      UserName: userName ?? '',
      Type: 1
    }

    this.subscriptions.add(
      this.patientPortal.GetValidatePatientPortalCredentials(param).subscribe({
        next: (resp: any) => {
          if (!this.authFlowState.isForgotPassword) {
            if (resp?.Status === 'Success' && resp?.IsValidPatient === true) {
              this.userNameNotExist = false;
              this.ReceivedOtpObj.MobileNo = resp.rows[0].MobileNo;
              this.ReceivedOtpObj.EmailId = resp.rows[0].EmailId;
              const patientData = {
                ...resp.rows[0],
                MobileNumber: resp.rows[0].MobileNo
              };

              this.patientDetailsByUserCredentials = patientData;
              this.authFlowState.isLoginWithOtp = true;
              this.setDefaultVerificationMethod(patientData);
            } else {
              this.setActiveTab(1);
              this.userNameNotExist = true;
            }
          } else {
            if (resp?.Status === 'Success' && resp?.IsValidPatient === true) {
              this.portalSessionDataService.set(SESSION_KEYS.LOGIN__USERNAME, resp.rows[0].UserName);
              this.userNameNotExist = false;
              this.isItsYouLoading = false;
              this.confirmItsYouOrNot();
            } else {
              this.isItsYouLoading = false;
              this.userNameNotExist = true;
            }
          }
        },
        error: () => {
          if (!this.authFlowState.isForgotPassword) {
            this.setActiveTab(1);
          }
          this.isItsYouLoading = false;
          this.userNameNotExist = false;
        }
      })
    );
  }






  //forgot password
  confirmItsYouOrNot() {
    const dob = this.confirmItsYou.controls.dob.getRawValue();
    const param = {
      UserName: this.confirmItsYou.controls.userName.value ?? '',
      DOB: DateUtil.toYMD(dob) ?? '',
      PatientId: this.selectedPatient.PatientId ?? null,
      HospitalId: this.parentOrganizationId ?? null,
      Type: 2
    }

    this.subscriptions.add(
      this.patientPortal.GetValidatePatientPortalCredentials(param).subscribe({
        next: (resp: any) => {
          if (resp.IsValidPatient && resp.Status === 'Success') {
            if (this.selectedPatient.PatientId === resp.rows[0].PatientId) {
              this.setActiveTab(7);
              this.patientForgetpatientobj = resp.rows[0];
              this.chooseAndConfirmPassword.patchValue({
                email: resp.rows[0].EmailId ?? '',
                userName: resp.rows[0].UserName ?? ''
              });
              this.isItsNotYou = false;
            } else {
              this.isItsNotYou = true;
            }
          } else {
            this.isItsNotYou = true;
          }
        },
        error: (err) => {
          this.isItsNotYou = true;
          console.error('Error while validating its you', err);
        }
      })
    );
  }




  //Reset data when move back
  private resetTabData(tab: number) {
    if (tab === 3 && (this.authFlowState.isLoginWithOtp || this.authFlowState.isCredentialsFlow)) {
      this.otpForm.reset();
      this.setupOtpUI();
      this.setActiveTab(2);
    } else {
      this.otpForm.reset();
      this.setupOtpUI();
      this.setActiveTab(4);
    }
  }

  private resetAllFormsAndState(): void {
    this.verificationForm.reset();
    this.otpForm.reset();
    this.patientSelectForm.reset();
    this.personalDetailsForm.reset();
    this.chooseAndConfirmPassword.reset();
    this.confirmItsYou.reset();
    this.noContactAvailable = false;
    this.personalDetailsSubmitted = false;
    Object.values(this.chooseAndConfirmPassword.controls).forEach(control => {
      control.setErrors(null);
    });

    this.userNameNotExist = false;
    this.hasUserName = false;
    this.isOtpLoading = false;
    this.showVerifyButton = true;
    this.showTimer = true;
    this.ResendOtpButton = false;
    this.otpInvalid = false;
    this.ShowMobileScreen = false;
    this.ShowOtpScreen = false;
    this.isOtpLogin = false;
    this.IsSelectEmailOrMobileValidate = false;
    this.otpValidationFailed = false;
    this.isSubmitOtpLoading = false;

    this.isDobMismatch = false;
    this.isFirstNameMismatch = false;
    this.isLastNameMismatch = false;
    this.isMobileMismatch = false;
    this.hasUserNameAndDob = false;
    this.isItsYouLoading = false;
    this.isItsNotYou = false;
    this.passwordMismatch = false;
    this.hasValuesInInputs = false;
    this.chooseAndConfirmLoad = false;

    this.stopOtpTimer();
    this.otpTimerSeconds = 0;
    this.OtpObj = this.otpObj();
    this.ReceivedOtpObj = this.receiveOtpObj();
    this.selectedPatient = this.createEmptyPatient();
    this.patientDetailsByUserCredentials = {};
    this.NewSignUpPatientList = [];
    this.patientForgetpatientobj = this.PatientForgetpatientobj();
    this.authFlowState = this.AuthFlowState();
    this.verificationMethod.reset({
      validateOption: 'number'
    });

    setTimeout(() => {
      this.setDefaultCountryCode();
    });
  }

  //Dynamic year change
  currentYear: number = new Date().getFullYear();

  //Show-hide password
  showPassword = false;
  confirmPassword = false;

  togglePassword(): void {
    this.showPassword = !this.showPassword;
  }
  toggleCPassword(): void {
    this.confirmPassword = !this.confirmPassword;
  }

  //Otp feild number only validation
  allowOnlyNumbers(event: KeyboardEvent) {
    const key = event.key;
    // Allow control keys
    if (['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight'].includes(key)) {
      return;
    }
    // Block non-numeric
    if (!/^[0-9]$/.test(key)) {
      event.preventDefault();
    }
  }
  
  private getDeviceInfo(): { deviceName: string; browser: string } {
    const ua = navigator.userAgent;

    // Browser detect
    let browser = 'Unknown Browser';
    if (ua.includes('Edg/')) browser = 'Edge';
    else if (ua.includes('OPR/') || ua.includes('Opera')) browser = 'Opera';
    else if (ua.includes('Chrome') && !ua.includes('Chromium')) browser = 'Chrome';
    else if (ua.includes('Firefox')) browser = 'Firefox';
    else if (ua.includes('Safari') && !ua.includes('Chrome')) browser = 'Safari';

    // Device name detect
    let deviceName = 'Desktop';
    if (/iPhone/.test(ua)) deviceName = 'iPhone';
    else if (/iPad/.test(ua)) deviceName = 'iPad';
    else if (/Android/.test(ua) && /Mobile/.test(ua)) deviceName = 'Android Phone';
    else if (/Android/.test(ua)) deviceName = 'Android Tablet';
    else if (/Macintosh/.test(ua)) deviceName = 'MacBook';
    else if (/Windows/.test(ua)) deviceName = 'Windows PC';

    return { deviceName, browser };
  }

  private async getLocation(): Promise<string> {
  try {
    const resp = await fetch('https://ipapi.co/json/');
    const data = await resp.json();
    return `${data.city}, ${data.country_name}`;
  } catch {
    return 'Unknown Location';
  }
}

private async addLoginDevice(patientId: number): Promise<void> {
  if (!this.isBrowser) return;

  const { deviceName, browser } = this.getDeviceInfo();
  const location = await this.getLocation();
  const loginDateTime = new Date().toISOString().slice(0, 19);

  const payload = {
    PatientId: patientId,
    DeviceName: deviceName,
    IsDeviceActiveInd: true,
    Browser: browser,
    Location: location,
    LoginDateTime: loginDateTime,
    DeleteInd: 'N'
  };

  this.patientPortal.AddUserDeviceDetails(payload).subscribe({
    next: () => {
      this.patientPortal.GetPatientDeviceDetails(patientId).subscribe({
        next: (deviceResp: any) => {
          const rows: any[] = deviceResp?.Rows ?? deviceResp?.rows ?? [];
          if (rows.length === 0) return;

          const loginTime = new Date(loginDateTime).getTime();
          const matched = rows
            .filter(d => d.Browser === browser && d.DeviceName === deviceName)
            .sort((a, b) => {
              const diffA = Math.abs(new Date(a.LoginDateTime).getTime() - loginTime);
              const diffB = Math.abs(new Date(b.LoginDateTime).getTime() - loginTime);
              return diffA - diffB;
            });

          const deviceId = matched[0]?.DeviceId ?? rows.at(-1)?.DeviceId ?? null;
          if (deviceId) {
            this.portalSessionDataService.set(SESSION_KEYS.CURRENT_DEVICE_ID, deviceId);
          }
        },
        error: (err) => console.error('Get device details failed', err)
      });
    },
    error: (err) => console.error('Device log failed', err)
  });
}
}
